var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5007 30.7646C25.7811 30.7646 31.6831 24.8627 31.6831 17.5823C31.6831 10.3018 25.7811 4.3999 18.5007 4.3999C11.2203 4.3999 5.31836 10.3018 5.31836 17.5823C5.31836 24.8627 11.2203 30.7646 18.5007 30.7646Z",
    stroke: "#303F9F",
    strokeWidth: 1.46471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4994 26.3705C19.4094 26.3705 20.1472 25.6328 20.1472 24.7227C20.1472 23.8127 19.4094 23.075 18.4994 23.075C17.5893 23.075 16.8516 23.8127 16.8516 24.7227C16.8516 25.6328 17.5893 26.3705 18.4994 26.3705Z",
    fill: "#303F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5011 19.7794V18.6809C19.2615 18.6809 20.0049 18.4554 20.6372 18.0329C21.2695 17.6105 21.7623 17.01 22.0533 16.3074C22.3443 15.6049 22.4204 14.8318 22.2721 14.086C22.1237 13.3401 21.7575 12.6551 21.2198 12.1173C20.6821 11.5796 19.997 11.2134 19.2512 11.0651C18.5054 10.9167 17.7323 10.9929 17.0297 11.2839C16.3272 11.5749 15.7267 12.0677 15.3042 12.7C14.8817 13.3323 14.6562 14.0756 14.6562 14.8361",
    stroke: "#303F9F",
    strokeWidth: 1.46471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionSign);
export default __webpack_public_path__ + "static/media/question_sign.a907e3e3619d85ee8e565087a65a491e.svg";
export { ForwardRef as ReactComponent };